
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2734',
  depVersions: {
  "customer-portal-app": "static-1.2734",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.484",
  "data-fetching-client": "static-1.9792",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25763",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5724",
  "hs-test-utils": "static-1.8151",
  "hub-http": "static-1.6353",
  "hub-http-shared-msw-handlers": "static-1.10289",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18605",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11601",
  "I18n": "static-7.1641",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6588",
  "payment-link-components": "static-1.23851",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7203",
  "quartz-core": "static-1.6422",
  "quartz-i18n": "static-1.878",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10338",
  "react-dlb": "static-1.81",
  "react-utils": "static-2.5440",
  "rich-text-lib": "static-1.20058",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18173",
  "ui-components-test-utils": "static-1.5738",
  "UIComponents": "static-3.8547",
  "foundations-assets": "static-1.5005",
  "foundations-components": "static-1.8193",
  "foundations-theming": "static-1.4564",
  "foundations-theming-specialty": "static-1.2280",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1187",
  "quartz-config": "static-1.981",
  "quartz-routing": "static-1.633",
  "quick-fetch": "static-1.4016",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1459-lcp-embedded-fields.3",
  "rpc-client-utils": "static-1.4788",
  "sanitize-text": "static-1.8278",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4891",
  "ui-addon-react-router-dom": "static-1.9667",
  "usage-tracker": "static-1.7482",
  "usage-tracker-anonymous": "static-1.5899",
  "usage-tracker-core": "static-1.7332",
  "video-components-external": "static-1.11711",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3497",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3480",
  "quartz-webpack": "static-1.3427",
  "bend-plugin-quartz-routing": "static-1.281",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7810",
  "frontend-preferences-client": "static-1.8057",
  "laboratory-lib": "static-3.7283",
  "onboarding-scopes": "static-1.6591",
  "seat-types-lib": "static-1.309",
  "ui-addon-opt": "static-4.8493",
  "HeadJS": "static-2.773",
  "hs-test-utils-bend-plugin": "static-1.3262",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.179",
  "ts-schema": "static-1.4180",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7962",
  "content-media-capture": "static-1.4918",
  "cssUtils": "static-1.831",
  "customer-data-ui-utilities": "static-1.9956",
  "file-manager-components": "static-1.23989",
  "HubStyle": "static-2.11908",
  "knowledge-content-types": "static-1.8559",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.10017",
  "ui-addon-i18n": "static-1.11280",
  "ui-business-units-lib": "static-1.9199",
  "ui-shepherd-react": "static-3.10384",
  "video-data-lib": "static-1.35369",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4456",
  "commerce-tours-lib": "static-1.6345",
  "customer-data-properties": "static-1.52008",
  "getting-started-shared-tasks": "static-1.18779",
  "growth-onboarding-reliability": "static-1.5212",
  "onboarding-tours": "static-1.16851",
  "reference-resolvers-lite": "static-1.8227",
  "sales-checkout-service-client": "static-1.3723",
  "ui-addon-iframeable": "static-1.9199",
  "user-context": "static-1.5239",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.848",
  "hubspotter-http": "static-1.4749",
  "icons": "static-2.656",
  "mobile-manifest-mixins": "static-1.547",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.878",
  "quartz-head": "static-1.868",
  "quartz-test": "static-1.878",
  "quartz-tracking": "static-1.582",
  "trellis-components": "static-1.2235",
  "ui-fonts": "static-1.863",
  "usage-tracker-container": "static-1.7472",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9554",
  "data-token-picker": "static-1.16639",
  "FileManagerLib": "static-1.39629",
  "property-translator": "static-1.5528",
  "atom": "static-1.5207",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6114",
  "salesImages": "static-1.527",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5676",
  "react-create-root-preference": "static-1.39",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1189",
  "bend-plugin-foundations-components": "static-1.4462",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2216",
  "bend-plugin-foundations-theming": "static-1.3047",
  "foundations-theming-base": "static-1.3549",
  "stylex": "static-1.35",
  "interframe": "static-3.4890",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5896",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.198",
  "chirp-fetch": "static-1.2019",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4608",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4782",
  "content-media-composition-data-lib": "static-1.12722",
  "content-media-compositions": "static-2.16729",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4281",
  "magpie-lib": "static-1.5641",
  "magpie-types": "static-1.5101",
  "media-bridge-lib": "static-1.19153",
  "bender-build-tools": "static-1.3301",
  "inbound-db-properties-service-client": "static-1.3944",
  "superstore": "static-1.4891",
  "feedback-loader": "static-1.29540",
  "ai-components-ui-library": "static-1.9282",
  "ui-addon-video-player": "static-1.8836",
  "ui-coaching-tips": "static-1.28925",
  "ContentUtils": "static-1.68748",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4557",
  "sassPrefix": "static-1.158",
  "react-dnd-compat": "static-1.4745",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1170",
  "copilot-toolkit": "static-1.11471",
  "avatar-components": "static-1.2629",
  "navigation-messaging": "static-1.7648",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8307",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.10054",
  "crm-message-bus": "static-1.43331",
  "growth-data-modal": "static-1.5645",
  "hubspot-apollo-client": "static-1.5009",
  "onboarding-tours-client": "static-1.5065",
  "calling-global-api": "static-1.64948",
  "calling-internal-common": "static-1.31443",
  "calling-lifecycle-internal": "static-1.66330",
  "calling-lifecycle-messages": "static-1.58624",
  "conditional-properties-service-client": "static-1.3896",
  "crm-links": "static-1.6439",
  "crm-pipelines-api-client-types": "static-1.4235",
  "customer-data-objects-ui-components": "static-1.13160",
  "customer-data-properties-shared-msw-handlers": "static-1.9616",
  "customer-data-property-utils": "static-1.8226",
  "external-options-client-types": "static-1.4225",
  "framework-data-schema-resolvers": "static-1.7025",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.308",
  "inbound-db-meta-service-client": "static-1.3685",
  "inbounddb-objects-service-types": "static-1.4316",
  "meetings-icalendar-utils-lib": "static-1.764",
  "multi-currency-client-types": "static-1.3789",
  "object-builder-ui-client": "static-1.49199",
  "pipeline-validation-client-types": "static-1.4064",
  "property-value-citations": "static-1.2622",
  "pulse": "static-1.735",
  "smart-property-lib": "static-1.7928",
  "tiered-pricing": "static-1.1557",
  "ui-addon-form-validation": "static-1.11122",
  "zustand": "static-1.74",
  "growth-onboarding-confetti": "static-1.3197",
  "growth-onboarding-next-action-utils": "static-1.2293",
  "navigation-components": "static-1.18321",
  "onboarding-tours-utils": "static-1.917",
  "ui-shepherd-tracker": "static-1.7765",
  "ui-universal-auth": "static-1.9136",
  "batch-promise": "static-1.1675",
  "getting-started-shared-tasks-store": "static-1.17897",
  "hubspotter-http-shared-msw-handlers": "static-1.10287",
  "usage-tracker-session-replay": "static-1.5168",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1074",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6118",
  "FileManagerCore": "static-1.39488",
  "FileManagerImages": "static-1.37140",
  "video-components": "static-1.13713",
  "foundations-components-legacy": "static-1.1218",
  "purchase-motions-api": "static-1.6117",
  "signup-constants": "static-1.19184",
  "signup-ui-url-generator": "static-2.8189",
  "usage-tracker-public": "static-1.7293",
  "reactive-lib": "static-1.857",
  "simple-logging-lib": "static-1.3180",
  "chatspot-core": "static-1.21915",
  "growth-onboarding-feedback-components": "static-1.6710",
  "cms-field-types": "static-1.4946",
  "content-icons-ui": "static-1.2265",
  "integrations-lib": "static-1.16568",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.448",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.907",
  "customer-data-tracking": "static-1.7017",
  "products-iframe-lib": "static-1.8291",
  "products-ui-components-shared-msw-handlers": "static-1.10671",
  "restore-request-side-panel-lib": "static-1.1218",
  "onboarding-data-sync-lib": "static-1.2195",
  "hubspot-apollo-cache": "static-1.468",
  "calling-error-reporting": "static-1.31450",
  "shared-worker-versioning": "static-1.11166",
  "calling-usage-tracker": "static-1.6675",
  "voice-sms-access-library": "static-1.1484",
  "conversations-skeleton-state": "static-1.7378",
  "location-customization-utils-lib": "static-1.9632",
  "fdsr-migration-layer": "static-1.144",
  "framework-builder-read-service-client": "static-1.4103",
  "framework-data-schema-quick-fetch": "static-1.6930",
  "persist-promise": "static-1.3832",
  "event-emitter": "static-1.1081",
  "bend-plugin-pulse": "static-1.238",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.412",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10372",
  "fsm": "static-1.3862",
  "policy-lib": "static-1.6917",
  "react-tinymce": "static-1.55591",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10435",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54717",
  "tinymce-plugins": "static-1.57831",
  "tinymce-themes": "static-1.56687",
  "growth-onboarding-next-action-components": "static-1.2321",
  "user-context-client": "static-1.4710",
  "nest": "static-1.363",
  "unified-auth-core-lib": "static-1.932",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4666",
  "video-embed": "static-1.36203",
  "social-insights-client-types": "static-1.22392",
  "flux-actions": "static-1.348",
  "integrations-error-boundary-lib": "static-1.13983",
  "integrations-tracking-lib": "static-1.5738",
  "native-integrations-shared-strings": "static-1.7912",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10493",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.650",
  "sales-views-client-types": "static-1.4388",
  "InboxConnectUtils": "static-4.15164",
  "meetings-connect-utils-lib": "static-1.7736",
  "calling-orchestration-schema": "static-1.36261",
  "crm-record-cards-service-types": "static-1.3683",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4641",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3174",
  "tinymce-data": "static-1.40802",
  "ui-addon-sales-email": "static-1.5341",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12702",
  "layout-dnd-utils": "static-1.11677",
  "react-codemirror": "static-1.10759",
  "ui-brand-identity-lib": "static-1.15747",
  "NamespacedHubStyle": "static-2.9152",
  "outpost": "static-1.4300",
  "universal-page-editor-lib": "static-1.3142",
  "adobe-sign-auth-lib": "static-1.58",
  "ads-unified-auth-lib": "static-1.476",
  "google-sheets-integration-lib": "static-1.623",
  "microsoft-drive-integration-lib": "static-1.778",
  "surveymonkey-integration-lib": "static-1.79",
  "slack-ui-library": "static-1.10528",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68823",
  "layout-data-lib": "static-1.10002",
  "browser-eslint": "static-2.57",
  "advanced-menus-core": "static-1.15346",
  "advanced-menus-lib": "static-1.12255",
  "ExportDialog": "static-6.10511",
  "ui-memberships-settings-lib": "static-1.34397",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15345",
  "simple-menus-lib": "static-1.16862"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2734",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.484",
  "data-fetching-client": "/data-fetching-client/static-1.9792",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25763",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5724",
  "hs-test-utils": "/hs-test-utils/static-1.8151",
  "hub-http": "/hub-http/static-1.6353",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10289",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18605",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11601",
  "I18n": "/I18n/static-7.1641",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6588",
  "payment-link-components": "/payment-link-components/static-1.23851",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7203",
  "quartz-core": "/quartz-core/static-1.6422",
  "quartz-i18n": "/quartz-i18n/static-1.878",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10338",
  "react-dlb": "/react-dlb/static-1.81",
  "react-utils": "/react-utils/static-2.5440",
  "rich-text-lib": "/rich-text-lib/static-1.20058",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18173",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5738",
  "UIComponents": "/UIComponents/static-3.8547",
  "foundations-assets": "/foundations-assets/static-1.5005",
  "foundations-components": "/foundations-components/static-1.8193",
  "foundations-theming": "/foundations-theming/static-1.4564",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2280",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1187",
  "quartz-config": "/quartz-config/static-1.981",
  "quartz-routing": "/quartz-routing/static-1.633",
  "quick-fetch": "/quick-fetch/static-1.4016",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-lcp-embedded-fields.3",
  "rpc-client-utils": "/rpc-client-utils/static-1.4788",
  "sanitize-text": "/sanitize-text/static-1.8278",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4891",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9667",
  "usage-tracker": "/usage-tracker/static-1.7482",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5899",
  "usage-tracker-core": "/usage-tracker-core/static-1.7332",
  "video-components-external": "/video-components-external/static-1.11711",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3497",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3480",
  "quartz-webpack": "/quartz-webpack/static-1.3427",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.281",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7810",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8057",
  "laboratory-lib": "/laboratory-lib/static-3.7283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6591",
  "seat-types-lib": "/seat-types-lib/static-1.309",
  "ui-addon-opt": "/ui-addon-opt/static-4.8493",
  "HeadJS": "/HeadJS/static-2.773",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3262",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.179",
  "ts-schema": "/ts-schema/static-1.4180",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7962",
  "content-media-capture": "/content-media-capture/static-1.4918",
  "cssUtils": "/cssUtils/static-1.831",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9956",
  "file-manager-components": "/file-manager-components/static-1.23989",
  "HubStyle": "/HubStyle/static-2.11908",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10017",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11280",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9199",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10384",
  "video-data-lib": "/video-data-lib/static-1.35369",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4456",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6345",
  "customer-data-properties": "/customer-data-properties/static-1.52008",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18779",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5212",
  "onboarding-tours": "/onboarding-tours/static-1.16851",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8227",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3723",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9199",
  "user-context": "/user-context/static-1.5239",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.848",
  "hubspotter-http": "/hubspotter-http/static-1.4749",
  "icons": "/icons/static-2.656",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.547",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.878",
  "quartz-head": "/quartz-head/static-1.868",
  "quartz-test": "/quartz-test/static-1.878",
  "quartz-tracking": "/quartz-tracking/static-1.582",
  "trellis-components": "/trellis-components/static-1.2235",
  "ui-fonts": "/ui-fonts/static-1.863",
  "usage-tracker-container": "/usage-tracker-container/static-1.7472",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9554",
  "data-token-picker": "/data-token-picker/static-1.16639",
  "FileManagerLib": "/FileManagerLib/static-1.39629",
  "property-translator": "/property-translator/static-1.5528",
  "atom": "/atom/static-1.5207",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6114",
  "salesImages": "/salesImages/static-1.527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5676",
  "react-create-root-preference": "/react-create-root-preference/static-1.39",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1189",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4462",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2216",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3047",
  "foundations-theming-base": "/foundations-theming-base/static-1.3549",
  "stylex": "/stylex/static-1.35",
  "interframe": "/interframe/static-3.4890",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5896",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.198",
  "chirp-fetch": "/chirp-fetch/static-1.2019",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4608",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4782",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12722",
  "content-media-compositions": "/content-media-compositions/static-2.16729",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4281",
  "magpie-lib": "/magpie-lib/static-1.5641",
  "magpie-types": "/magpie-types/static-1.5101",
  "media-bridge-lib": "/media-bridge-lib/static-1.19153",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3944",
  "superstore": "/superstore/static-1.4891",
  "feedback-loader": "/feedback-loader/static-1.29540",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9282",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8836",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28925",
  "ContentUtils": "/ContentUtils/static-1.68748",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4557",
  "sassPrefix": "/sassPrefix/static-1.158",
  "react-dnd-compat": "/react-dnd-compat/static-1.4745",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1170",
  "copilot-toolkit": "/copilot-toolkit/static-1.11471",
  "avatar-components": "/avatar-components/static-1.2629",
  "navigation-messaging": "/navigation-messaging/static-1.7648",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8307",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.10054",
  "crm-message-bus": "/crm-message-bus/static-1.43331",
  "growth-data-modal": "/growth-data-modal/static-1.5645",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5009",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5065",
  "calling-global-api": "/calling-global-api/static-1.64948",
  "calling-internal-common": "/calling-internal-common/static-1.31443",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66330",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58624",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3896",
  "crm-links": "/crm-links/static-1.6439",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4235",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13160",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9616",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8226",
  "external-options-client-types": "/external-options-client-types/static-1.4225",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7025",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.308",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3685",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4316",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.764",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3789",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49199",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4064",
  "property-value-citations": "/property-value-citations/static-1.2622",
  "pulse": "/pulse/static-1.735",
  "smart-property-lib": "/smart-property-lib/static-1.7928",
  "tiered-pricing": "/tiered-pricing/static-1.1557",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11122",
  "zustand": "/zustand/static-1.74",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3197",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2293",
  "navigation-components": "/navigation-components/static-1.18321",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.917",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7765",
  "ui-universal-auth": "/ui-universal-auth/static-1.9136",
  "batch-promise": "/batch-promise/static-1.1675",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17897",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10287",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5168",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1074",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6118",
  "FileManagerCore": "/FileManagerCore/static-1.39488",
  "FileManagerImages": "/FileManagerImages/static-1.37140",
  "video-components": "/video-components/static-1.13713",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1218",
  "purchase-motions-api": "/purchase-motions-api/static-1.6117",
  "signup-constants": "/signup-constants/static-1.19184",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8189",
  "usage-tracker-public": "/usage-tracker-public/static-1.7293",
  "reactive-lib": "/reactive-lib/static-1.857",
  "simple-logging-lib": "/simple-logging-lib/static-1.3180",
  "chatspot-core": "/chatspot-core/static-1.21915",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6710",
  "cms-field-types": "/cms-field-types/static-1.4946",
  "content-icons-ui": "/content-icons-ui/static-1.2265",
  "integrations-lib": "/integrations-lib/static-1.16568",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.448",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.907",
  "customer-data-tracking": "/customer-data-tracking/static-1.7017",
  "products-iframe-lib": "/products-iframe-lib/static-1.8291",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10671",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1218",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2195",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.468",
  "calling-error-reporting": "/calling-error-reporting/static-1.31450",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11166",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6675",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1484",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7378",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9632",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.144",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4103",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6930",
  "persist-promise": "/persist-promise/static-1.3832",
  "event-emitter": "/event-emitter/static-1.1081",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.238",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.412",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10372",
  "fsm": "/fsm/static-1.3862",
  "policy-lib": "/policy-lib/static-1.6917",
  "react-tinymce": "/react-tinymce/static-1.55591",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10435",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54717",
  "tinymce-plugins": "/tinymce-plugins/static-1.57831",
  "tinymce-themes": "/tinymce-themes/static-1.56687",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2321",
  "user-context-client": "/user-context-client/static-1.4710",
  "nest": "/nest/static-1.363",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.932",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4666",
  "video-embed": "/video-embed/static-1.36203",
  "social-insights-client-types": "/social-insights-client-types/static-1.22392",
  "flux-actions": "/flux-actions/static-1.348",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13983",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5738",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7912",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10493",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.650",
  "sales-views-client-types": "/sales-views-client-types/static-1.4388",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15164",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7736",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36261",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3683",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4641",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3174",
  "tinymce-data": "/tinymce-data/static-1.40802",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5341",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12702",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11677",
  "react-codemirror": "/react-codemirror/static-1.10759",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15747",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9152",
  "outpost": "/outpost/static-1.4300",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3142",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.58",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.476",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.623",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.778",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.79",
  "slack-ui-library": "/slack-ui-library/static-1.10528",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68823",
  "layout-data-lib": "/layout-data-lib/static-1.10002",
  "browser-eslint": "/browser-eslint/static-2.57",
  "advanced-menus-core": "/advanced-menus-core/static-1.15346",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12255",
  "ExportDialog": "/ExportDialog/static-6.10511",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34397",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15345",
  "simple-menus-lib": "/simple-menus-lib/static-1.16862"
}
};
